export const languages = [
    {
        language_id: "1",
        code: "en",
        label: "English",
        short: "EN"
    },
    {
        language_id: "2",
        code: "fr",
        label: "French",
        short: "FR"
    },
    {
        language_id: "3",
        code: "pt", 
        label: "Portuguese", 
        short: "PT"
    },
]